import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IJoinTwilioRoomArgs,
  ITwilioRoom,
  ITwilioState,
  PermissionErrors,
} from '../../types/twilio';

const initialState: ITwilioState = {
  twilioRoomData: null,
  participants: [],
  muted: false,
  cameraDisabled: false,
  microphoneDisabled: false,
  isFullScreen: false,
  localDisplayMode: 'window',
  twilioErrorMessage: '',
  permissionError: '',
};

const twilioSlice = createSlice({
  name: 'twilio',
  initialState,
  reducers: {
    joinTwilioRoomRequest: (state, _: PayloadAction<IJoinTwilioRoomArgs>) => {
      state.joinTwilioRoomRequestStatus = 'pending';
    },
    joinTwilioRoomRequestError: (state, action: PayloadAction<string>) => {
      state.joinTwilioRoomRequestStatus = 'error';
      state.twilioErrorMessage = action.payload;
      state.twilioRoomData = null;
    },
    joinTwilioRoomRequestSuccess: (state, action: PayloadAction<ITwilioRoom>) => {
      state.joinTwilioRoomRequestStatus = 'success';
      state.twilioRoomData = action.payload;
      state.twilioErrorMessage = '';
    },
    resetTwilioRoom: (state) => {
      return { ...initialState, joinTwilioRoomRequestStatus: state.joinTwilioRoomRequestStatus };
    },
    toggleMuted: (state) => {
      state.muted = !state.muted;
    },
    toggleCameraDisabled: (state) => {
      state.cameraDisabled = !state.cameraDisabled;
    },
    toggleMicrophone: (state) => {
      state.microphoneDisabled = !state.microphoneDisabled;
    },
    toggleFullScreen: (state) => {
      state.isFullScreen = !state.isFullScreen;
    },
    toggleLocalDisplayMode: (state) => {
      state.localDisplayMode = state.localDisplayMode === 'full' ? 'window' : 'full';
    },
    setErrorMessage: (state, action: PayloadAction<string>) => {
      state.twilioErrorMessage = action.payload;
    },
    setPermissionError: (state, action: PayloadAction<PermissionErrors>) => {
      state.permissionError = action.payload;
    },
  },
});

export const { actions, name, reducer } = twilioSlice;
export default reducer;
